import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Divider,
  Box,
  ListItemButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ArticleIcon from "@mui/icons-material/Article";
import EventIcon from "@mui/icons-material/Event";
import InstagramIcon from "@mui/icons-material/Instagram";
import CollectionsIcon from "@mui/icons-material/Collections";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";

import logo from "../assets/images/logo.png";
import Colors from "../assets/color";

import Home from "./Home/Home";
import NewJoinMembers from "./Home/NewJoinMembers";
import BlogScreen from "./Blog/BlogScreen";
import CreateBlogScreen from "./Blog/CreateBlog";
import EditBlog from "./Blog/EditBlog";
import EventScreen from "./Event/EventScreen";
import CreateEvent from "./Event/CreateEvent";
import EditEvent from "./Event/EditEvent";
import RegisteredUsersScreen from "./Booking/RegisteredUsersScreen";
import CreateInsta from "./insta/CreateInsta";
import InstagramScreen from "./insta/InstagramScreen";
import GalleryScreen from "./Gallery/GalleryScreen";
import CreateGallery from "./Gallery/CreateGallery";
import EditGallery from "./Gallery/EditGallery";
import ContactUsScreen from "./ContactUs/ContactUsScreen";
import BroadcastScreen from "./Broadcast/BroadcastScreen";

const drawerWidth = 240;

const Dashboard = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const isActive = (path) => location.pathname.startsWith(path);

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/home")}
            onClick={() => handleNavigation("/home")}
          >
            <ListItemIcon>
              <HomeIcon color={isActive("/home") ? "primary" : "inherit"} />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/blog")}
            onClick={() => handleNavigation("/blog")}
          >
            <ListItemIcon>
              <ArticleIcon color={isActive("/blog") ? "primary" : "inherit"} />
            </ListItemIcon>
            <ListItemText primary="Blog" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/event")}
            onClick={() => handleNavigation("/event")}
          >
            <ListItemIcon>
              <EventIcon color={isActive("/event") ? "primary" : "inherit"} />
            </ListItemIcon>
            <ListItemText primary="Event" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/gallery")}
            onClick={() => handleNavigation("/gallery")}
          >
            <ListItemIcon>
              <CollectionsIcon
                color={isActive("/gallery") ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText primary="Gallery" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/instagram-post")}
            onClick={() => handleNavigation("/instagram-post")}
          >
            <ListItemIcon>
              <InstagramIcon
                color={isActive("/instagram-post") ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText primary="SocialMedia Post" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/contact-us")}
            onClick={() => handleNavigation("/contact-us")}
          >
            <ListItemIcon>
              <ContactMailIcon
                color={isActive("/contact-us") ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText primary="Messages" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            selected={isActive("/broadcast")}
            onClick={() => handleNavigation("/broadcast")}
          >
            <ListItemIcon>
              <AnnouncementIcon
                color={isActive("/broadcast") ? "primary" : "inherit"}
              />
            </ListItemIcon>
            <ListItemText primary="Broadcast Messages" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: Colors.background,
        }}
      >
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ color: "#005b7d", mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <img src={logo} alt="Logo" style={{ height: 40, marginRight: 8 }} />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ color: Colors.black }}
          >
            Social Paws
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="dashboard folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/new-join-members" element={<NewJoinMembers />} />
          <Route path="/select-members" element={<NewJoinMembers selectionMode />} />
          <Route path="/blog" element={<BlogScreen />} />
          <Route path="/blog/create" element={<CreateBlogScreen />} />
          <Route path="/blog/edit" element={<EditBlog />} />
          <Route path="/event" element={<EventScreen />} />
          <Route path="/event/create" element={<CreateEvent />} />
          <Route path="/event/edit" element={<EditEvent />} />
          <Route
            path="/event/registered-users"
            element={<RegisteredUsersScreen />}
          />
          <Route path="/instagram-post" element={<InstagramScreen />} />
          <Route path="/instagram-post/create" element={<CreateInsta />} />
          <Route path="/gallery" element={<GalleryScreen />} />
          <Route path="/gallery/create" element={<CreateGallery />} />
          <Route path="/gallery/edit" element={<EditGallery />} />
          <Route path="/contact-us" element={<ContactUsScreen />} />
          <Route path="/broadcast" element={<BroadcastScreen />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default Dashboard;
